import * as React from 'react';
import { observer } from 'mobx-react';
import { JSSClassesProps } from 'react-jss';
import { ComponentJSSClasses } from './styles';
import { ReviewsSources } from '../../../../models/hotel-reviews';
import S from '../../../../stores';

import cl from 'classnames';
import { EnableTopHotels } from '../../../../../consts/flags';

export interface ReviewsSourcesToggleProps { }
interface StyledReviewsSourcesToggleProps extends JSSClassesProps<ComponentJSSClasses> { }

export const ReviewsSourcesToggle = observer(function ReviewsSourcesToggle(props: StyledReviewsSourcesToggleProps) {
    const { classes: c } = props;

    const renderTopHotelsButton = () => {
        if (!EnableTopHotels) {
            return null;
        }
        return (
            <button
                type="button"
                className={cl(c.button, { [c.active]: S.hotelReviews.selectedReviewsSources === ReviewsSources.TopHotels })}
                onClick={() => S.hotelReviews.toggleReviewsSources(ReviewsSources.TopHotels)}
            >
                TopHotels
            </button>
        );
    };

    return (
        <section className={c.buttonGroup}>
            <button
                type="button"
                className={cl(c.button, { [c.active]: S.hotelReviews.selectedReviewsSources === ReviewsSources.Others })}
                onClick={() => S.hotelReviews.toggleReviewsSources(ReviewsSources.Others)}
            >
                Рейтинг и отзывы
            </button>
            {renderTopHotelsButton()}
        </section>
    );
});
